var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-btn',{class:_vm.$q.screen.lt.sm ? 'q-py-sm' : 'q-py-md',attrs:{"rounded":"","color":"register-button","icon":"how_to_reg","label":_vm.btn_label,"size":_vm.$q.screen.lt.sm ? "sm" : "12px"},on:{"click":_vm.redirectToRegister}})
}
var staticRenderFns = []

export { render, staticRenderFns }